import { Bill } from '../components/bills/Bills'

export const billWithName = (bill: Bill) => bill.name.length > 0

export const methodfiBill = (bill: Bill) => bill.provider === 'METHOD_FI'

export const notLoans = (bill: Bill) => bill.type !== 'LOAN'

export const notConnectedBill = (bill: Bill) => !bill.connected

export const sortAlphabetically = (a: Bill, b: Bill) =>
    a.name!.toLowerCase().localeCompare(b.name.toLowerCase())

export const sortOpenedDate = (a: Bill, b: Bill) =>
    new Date(b.openedAt!).getTime() - new Date(a.openedAt!).getTime()
